import React, { useEffect } from "react";
import ChildComponentLegacy from "../../../components/applicationComponents/legacy/child/ChildComponentLegacy";
import { useApplicationContext } from "../../../components/applicationComponents/context/applicationContext";

export default function ChildPageLegacy() {
  const { setHeaderText } = useApplicationContext();
  useEffect(() => {
    setHeaderText({
      value: "Edit Child Details",
      icon: "view-app-icon mr-3 mt-0",
    });
  }, []);

  return (
    <>
      <ChildComponentLegacy disabled={false} />
    </>
  );
}
